export default __webpack_public_path__ + "static/media/IkonTag.5dacf10e.svg";